// extracted by mini-css-extract-plugin
export default {"wrapper":"Jea","container":"Kea","image":"Lea","info":"Mea","title":"Nea","note":"Oea","product":"Pea","product_img":"Qea","description":"Rea","name":"Sea","whybtn":"Tea","buttons":"Uea"};
    if(module.hot) {
      // 1743628931629
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  